import api from './index';
let exports = {};

exports.getAsmblAccDefList = function (data, callback) {
    api.post('/asmbl/acc/def/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getAsmblAccDef = function (data, callback) {
    api.get('/asmbl/acc/def/get')
    .params(data)
    .done(callback)
    .go();
};

exports.getAsmblAccDefByUK = function (data, callback) {
    api.post('/asmbl/acc/def/get/by/uk')
    .data(data)
    .done(callback)
    .go();
};

exports.getAsmblAccDefByUK2 = function (params, callback) {
    api.get('/asmbl/acc/def/get/by/innerCode')
    .params(params)
    .done(callback)
    .go();
};

exports.saveAsmblAccDef = function (data, callback) {
    api.post('/asmbl/acc/def/save')
    .data(data)
    .done(callback)
    .go();
};

exports.updateAsmblAccDef = function (data, callback) {
    api.post('/asmbl/acc/def/update')
    .data(data)
    .done(callback)
    .go();
};

exports.doAsmblAccDefDisabled = function (data, callback) {
    api.post('/asmbl/acc/def/disabled')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteAsmblAccDef = function (data, callback) {
    api.post('/asmbl/acc/def/delete')
    .data(data)
    .done(callback)
    .go();
};
exports.validateAsmblAccDefImpModel = function (data, callback) {// 导入验证
    api.post('/asmbl/acc/def/imp/model/validate')
    .data(data)
    .done(callback)
    .go();
};
exports.doAsmblAccDefImpModelImport = function (data, callback) {// 资产定义导入
    api.post('/asmbl/acc/def/imp/model/import/do')
    .data(data)
    .done(callback)
    .go();
};
exports.asmblAccDefImpModelForExport = function (data, callback) {// 资产定义导出当前导入数据
    api.post('/asmbl/acc/del/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .go();
};
// =================== 门店组装件出入库条目 ====================

// 组装件库存
exports.getShopAsmblAccIoRecStockList = function (data, callback) {
    api.post('/asmbl/acc/io/rec/stock/list')
    .data(data)
    .done(callback)
    .go();
};

// 组装件记录 - 分页
exports.getShopAsmblAccIoRecPageList = function (data, callback) {
    api.post('/asmbl/acc/io/rec/list')
    .data(data)
    .done(callback)
    .go();
};
// 不分页
exports.getShopAsmblAccIoRecList = function (data, callback) {
    api.post('/asmbl/acc/io/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/asmblAcc.js
// module id = 61
// module chunks = 0